<template>
    <div class="app-container">
        <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="80px">
            <el-form-item label="房号" prop="fangNo">
                <el-input
                    v-model="queryParams.fangNo"
                    placeholder="请输入房号"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="入住人" prop="userName">
                <el-input
                    v-model="queryParams.userName"
                    placeholder="请输入入住人"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table v-loading="loading" :data="fankuiList" @selection-change="handleSelectionChange">
            <!--      <el-table-column type="selection" width="55" align="center"/>-->
            <!--      <el-table-column label="${comment}" align="center" prop="id" />-->
            <el-table-column label="房型" align="center" prop="xingName"/>
            <el-table-column label="房号" align="center" prop="fangNo"/>
            <el-table-column label="入住人" align="center" prop="userName"/>
            <el-table-column label="入住日期" align="center" prop="startDate"/>
            <el-table-column label="截止日期" align="center" prop="endDate"/>
            <el-table-column label="入住月数" align="center" prop="month">
                <template slot-scope="scope">
                    <label>{{ scope.row.month }}个月</label>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center" prop="fangStatus">
                <template slot-scope="scope">
                    <label style="color: #F56C6C" v-if="scope.row.fangStatus=='1'">待入住</label>
                    <label style="color: #409EFF" v-if="scope.row.fangStatus=='2'">已入住</label>
                    <label style="color: #67C23A" v-if="scope.row.fangStatus=='3'">已到期</label>
                    <label style="color: #E6A23C" v-if="scope.row.fangStatus=='4'">已结束</label>
                </template>
            </el-table-column>
            <el-table-column label="距离到期" align="center" prop="daoQiDay">
                <template slot-scope="scope">
                    <label style="color: #F56C6C" v-if="scope.row.daoQiDay<0">{{ scope.row.daoQiDay }}天</label>
                    <label style="color: #67C23A" v-if="scope.row.daoQiDay>=0">{{ scope.row.daoQiDay }}天</label>
                </template>
            </el-table-column>
            <!--            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-button-->
            <!--                  size="mini"-->
            <!--                  type="text"-->
            <!--                  @click="handleUpdate(scope.row)"-->
            <!--                  v-if="scope.row.status=='未处理'"-->
            <!--                >已处理-->
            <!--                </el-button>-->
            <!--                &lt;!&ndash;          <el-button&ndash;&gt;-->
            <!--                &lt;!&ndash;            size="mini"&ndash;&gt;-->
            <!--                &lt;!&ndash;            type="text"&ndash;&gt;-->
            <!--                &lt;!&ndash;            icon="el-icon-delete"&ndash;&gt;-->
            <!--                &lt;!&ndash;            @click="handleDelete(scope.row)"&ndash;&gt;-->
            <!--                &lt;!&ndash;            v-hasPermi="['fang:fankui:remove']"&ndash;&gt;-->
            <!--                &lt;!&ndash;          >删除</el-button>&ndash;&gt;-->
            <!--              </template>-->
            <!--            </el-table-column>-->
        </el-table>

        <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />

        <!-- 添加或修改问题反馈对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                <el-form-item label="问题内容" prop="wenTi">
                    <el-input v-model="form.wenTi" placeholder="请输入问题内容"/>
                </el-form-item>
                <el-form-item label="图片" prop="img">
                    <image-upload v-model="form.img"/>
                </el-form-item>
                <!--        <el-form-item label="房号" prop="fangNo">-->
                <!--          <el-input v-model="form.fangNo" placeholder="请输入房号" />-->
                <!--        </el-form-item>-->
                <!--        <el-form-item label="入住人" prop="userName">-->
                <!--          <el-input v-model="form.userName" placeholder="请输入入住人" />-->
                <!--        </el-form-item>-->
                <!--        <el-form-item label="手机号" prop="phone">-->
                <!--          <el-input v-model="form.phone" placeholder="请输入手机号" />-->
                <!--        </el-form-item>-->
                <!--        <el-form-item label="删除标志" prop="delFlag">-->
                <!--          <el-input v-model="form.delFlag" placeholder="请输入删除标志" />-->
                <!--        </el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {daibanfangzu} from "@/api/homestay/api";

export default {
    name: "Fankui",
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 问题反馈表格数据
            fankuiList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                fangNo: null,
                userName: null
            },
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    {required: true, message: "$comment不能为空", trigger: "blur"}
                ],
                wenTi: [
                    {required: true, message: "问题内容不能为空", trigger: "blur"}
                ],
                img: [
                    {required: true, message: "图片不能为空", trigger: "blur"}
                ],
                fangNo: [
                    {required: true, message: "房号不能为空", trigger: "blur"}
                ],
                userName: [
                    {required: true, message: "入住人不能为空", trigger: "blur"}
                ],
                phone: [
                    {required: true, message: "手机号不能为空", trigger: "blur"}
                ],
                status: [
                    {required: true, message: "状态 未处理  已处理不能为空", trigger: "blur"}
                ],
                delFlag: [
                    {required: true, message: "删除标志不能为空", trigger: "blur"}
                ],
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        /** 查询问题反馈列表 */
        getList() {
            this.loading = true;
            daibanfangzu(this.queryParams).then(response => {
                this.fankuiList = response.data;
                this.total = response.total;
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                wenTi: null,
                img: null,
                fangNo: null,
                userName: null,
                phone: null,
                status: "0",
                delFlag: null,
            };
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length !== 1
            this.multiple = !selection.length
        },
    }
};
</script>
